import { Box, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ApplicableOrNotApplicable,
  FormClassRetire,
  FormKbn,
  Prefectures,
  RetireFlowReason,
  RetireReason,
  Status,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkButton from "../../components/atoms/TkButton";
import TkStepper from "../../components/atoms/TkStepper";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpIAPI_STA003, httpIAPI_STA008 } from "./api/request";
import {
  makeChildcareLeaveBodyList,
  makeWorkingDayNumInfoBodyList,
  makeSixMonthsSalaryBodyList,
} from "./hooks/useHooks";
import {
  childHeadList,
  headListWorkingDayNum,
  fakeTableList,
  salaryHeadList,
  stepper,
} from "./parts";
import { API_STA008_BuildReqParams } from "../../utils/buildRequestParams";
import { changeZipcodeFormat } from "../../utils/useTools";
import _ from "lodash";

/**
 * SCRC060028 退職情報　登録（登録内容の確認）
 * @return SCRC060028 退職情報　登録（登録内容の確認）
 */
const SCRC060028 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState } = useContext(BusinessContext);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const dataInfo = businessState.job_32;
  let job_33Flg =
    dataInfo?.continueTransferApplicable1Flg ===
      ApplicableOrNotApplicable["該当"] &&
    dataInfo?.continueTransferApplicable2Flg ===
      ApplicableOrNotApplicable["該当"];
  const [childBodyList, setChildBodyList] = useState<any>([]);
  const [childcareLeaveWorkingDayNumList, setChildcareLeaveWorkingDayNumList] =
    useState<any>([]);
  const [salaryBodyList, setSalaryBodyList] = useState<any>([]);
  const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
  const [activeStep, setActiveStep] = useState(3);
  const [isBtnVisible, setIsBtnVisible] = useState(true);

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSetStaffName = (
    bNameKanji: any,
    bNameKana: any,
    staffNameKanji: any,
    staffNameKana: any
  ) => {
    let resArr = stateFakeTableList.current;
    // 職員番号
    resArr.find((item) => item.keyword === "staffNo")!.text = dataInfo?.staffNo;

    // 退職者名（新）
    const staffNameKanjiInput = resArr.find(
      (item) => item.keyword === "staffNameKanji"
    )!;
    // 退職者名カナ（新）
    const staffNameKanaInput = resArr.find(
      (item) => item.keyword === "staffNameKana"
    )!;
    // 退職者名漢字
    const bNameKanjiInput = resArr.find(
      (item) => item.keyword === "bNameKanji"
    )!;
    // 退職者名カナ
    const bNameKanaInput = resArr.find((item) => item.keyword === "bNameKana")!;
    if (bNameKanji) {
      staffNameKanjiInput.text = staffNameKanji;
      bNameKanjiInput.text = bNameKanji;
    } else {
      staffNameKanjiInput.showLine = false;
      bNameKanjiInput.text = staffNameKanji;
    }

    if (bNameKana) {
      staffNameKanaInput.text = staffNameKana;
      bNameKanaInput.text = bNameKana;
    } else {
      staffNameKanaInput.showLine = false;
      bNameKanaInput.text = staffNameKana;
    }
  };

  const handleSetStaffNameInit = (
    bNameKanji: any,
    bNameKana: any,
    staffNameKanji: any,
    staffNameKana: any
  ) => {
    let resArr = stateFakeTableList.current;

    // 退職者名（新）
    const staffNameKanjiInput = resArr.find(
      (item) => item.keyword === "staffNameKanji"
    )!;
    // 退職者名カナ（新）
    const staffNameKanaInput = resArr.find(
      (item) => item.keyword === "staffNameKana"
    )!;
    // 退職者名漢字
    const bNameKanjiInput = resArr.find(
      (item) => item.keyword === "bNameKanji"
    )!;
    // 退職者名カナ
    const bNameKanaInput = resArr.find((item) => item.keyword === "bNameKana")!;
    if (bNameKanji) {
      staffNameKanjiInput.text = staffNameKanji;
      bNameKanjiInput.text = bNameKanji;
    } else {
      staffNameKanjiInput.showLine = false;
      bNameKanjiInput.text = staffNameKanji;
    }

    if (bNameKana) {
      staffNameKanaInput.text = staffNameKana;
      bNameKanaInput.text = bNameKana;
    } else {
      staffNameKanaInput.showLine = false;
      bNameKanaInput.text = staffNameKana;
    }
  };
  // 初期表示
  const handleInit = async () => {
    if (location.state?.applyId) {
      try {
        const res = await httpIAPI_STA003({
          applyId: location.state.applyId,
          contractorNo: isKiko
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo,
        });
        if (res.resultCd === "I0000") {
          if (
            !(
              res.latestApplyStatus === Status["届出待ち"] ||
              res.latestApplyStatus === Status["差戻し一時保存"]
            )
          ) {
            setActiveStep(5);
            setIsBtnVisible(false);
          }

          let resArr = stateFakeTableList.current;
          // 職員番号
          resArr.find((item) => item.keyword === "staffNo")!.text = res.staffNo;

          handleSetStaffNameInit(
            res?.bNameKanji,
            res?.bNameKana,
            res?.staffNameKanji,
            res?.staffNameKana
          );

          // 法人職員生年月日
          resArr.find((item) => item.keyword === "birthday")!.text =
            res.birthday;
          // 退職年月日
          resArr.find((item) => item.keyword === "retireDate")!.text =
            res.retireDate;
          // 退職者郵便番号
          resArr.find((item) => item.keyword === "zipcode")!.text =
            changeZipcodeFormat(res.zipcode);

          // 退職者住所
          resArr.find(
            (item) => item.keyword === "address"
          )!.text = `${TkGetCode(Prefectures, res.prefectureCd)}${
            res.addressCity
          }${res.addressOthers}`;

          // 退職者電話番号
          resArr.find((item) => item.keyword === "tel")!.text = res.tel;
          // 退職理由
          resArr.find(
            (item) => item.keyword === "retireReason"
          )!.text = `${TkGetCode(RetireReason, res?.nRetireReasonCd)}`;
          // 退職手続きの理由
          resArr.find(
            (item) => item.keyword === "retireProcedureReason"
          )!.text = `${TkGetCode(RetireFlowReason, res.retireProcedureReason)}`;
          // ならない月
          let exclusionMonth = resArr.find(
            (item) => item.keyword === "exclusionMonth"
          )!;
          let checkedList = exclusionMonth.checkBoxList
            ?.filter((item) => res[item.value as keyof typeof res] === "1")!
            .map((item) => item.label);

          exclusionMonth.setDefaultValue = checkedList?.length
            ? checkedList
            : ["無"];

          // 現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である
          resArr.find(
            (item) => item.keyword === "continueTransferApplicable1Flg"
          )!.text = TkGetCode(
            ApplicableOrNotApplicable,
            res.continueTransferApplicable1Flg
          );

          // 現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である
          resArr.find(
            (item) => item.keyword === "continueTransferApplicable2Flg"
          )!.text = TkGetCode(
            ApplicableOrNotApplicable,
            res.continueTransferApplicable2Flg
          );

          // 転職先の共済契約者番号
          let aContractorNo = resArr.find(
            (item) => item.keyword === "aContractorNo"
          )!;
          aContractorNo.text = res.aContractorNo;
          aContractorNo.showLine =
            res.continueTransferApplicable1Flg ===
            ApplicableOrNotApplicable["該当"];

          // 転職先の共済契約者名
          let aCorpName = resArr.find((item) => item.keyword === "aCorpName")!;
          aCorpName.text = res.aCorpName;
          aCorpName.showLine =
            res.continueTransferApplicable2Flg ===
            ApplicableOrNotApplicable["該当"];

          // 当月の出勤日数
          resArr.find((item) => item.keyword === "workingDayNum")!.text =
            res.workingDayNum;

          setChildBodyList(
            makeChildcareLeaveBodyList(res.childcareLeaveList || [])
          );
          setChildcareLeaveWorkingDayNumList(
            makeWorkingDayNumInfoBodyList(
              res.childcareLeaveWorkingDayNumList || []
            )
          );
          setSalaryBodyList(
            makeSixMonthsSalaryBodyList(
              res.sixMonthsSalaryBeforeApplyList || []
            )
          );

          // 賃金台帳
          const wagesFile = res?.formList?.find(
            (item) =>
              item.formKbn === FormKbn["退職書類"] &&
              item.formClass === FormClassRetire["賃金台帳"]
          );
          if (wagesFile) {
            let wages = resArr.find((item) => item.keyword === "wages")!;

            wages.dataname = wagesFile.formName;
            wages.base64filedata = wagesFile.fileBase64;

            wages.showLine = true;
          }

          // 雇用契約書
          const contractEmploymentFile = res.formList?.find(
            (item) =>
              item.formKbn === FormKbn["退職書類"] &&
              item.formClass === FormClassRetire["雇用契約書"]
          );
          if (contractEmploymentFile) {
            let contractEmployment = resArr.find(
              (item) => item.keyword === "contractEmployment"
            )!;

            contractEmployment.dataname = contractEmploymentFile.formName;
            contractEmployment.base64filedata =
              contractEmploymentFile.fileBase64;

            contractEmployment.showLine = true;
          }

          setStateInfoList(resArr);
        } else {
          navigate("/error");
        }
      } catch (error) {
        navigate("/error");
      }
    } else {
      let resArr = stateFakeTableList.current;
      let resList =
        dataInfo?.childcareLeaveRegistrationInfo?.childcareLeaveInfoList;
      let workingDayNumList =
        dataInfo?.childcareLeaveRegistrationInfo?.childcareActiveListList;
      let sixMonList = dataInfo?.sixMonthsSalaryBeforeApplyList;

      setChildBodyList(makeChildcareLeaveBodyList(resList!));
      setChildcareLeaveWorkingDayNumList(
        makeWorkingDayNumInfoBodyList(workingDayNumList!)
      );
      setSalaryBodyList(makeSixMonthsSalaryBodyList(sixMonList!));

      // 契約者（法人）名
      let contractorName = resArr.find(
        (item) => item.keyword === "contractorName"
      )!;
      contractorName.contractorNumber =
        businessState.common?.contractorNo +
        ":" +
        businessState.common?.contractorName;
      contractorName.showLine = isKiko;

      // 職員番号
      resArr.find((item) => item.keyword === "staffNo")!.text =
        dataInfo?.staffNo;

      handleSetStaffName(
        dataInfo?.bNameKanji,
        dataInfo?.bNameKana,
        dataInfo?.staffNameKanji,
        dataInfo?.staffNameKana
      );

      // 法人職員生年月日
      resArr.find((item) => item.keyword === "birthday")!.text =
        dataInfo?.birthday;

      // 退職年月日
      resArr.find((item) => item.keyword === "retireDate")!.text =
        dataInfo?.retireDate;

      // 退職理由
      resArr.find(
        (item) => item.keyword === "retireReason"
      )!.text = `${TkGetCode(RetireReason, dataInfo?.nRetireReasonCd)}`;

      // 退職手続きの理由
      resArr.find(
        (item) => item.keyword === "retireProcedureReason"
      )!.text = `${TkGetCode(
        RetireFlowReason,
        dataInfo?.retireProcedureReason
      )}`;

      // 退職者郵便番号
      resArr.find((item) => item.keyword === "zipcode")!.text =
        changeZipcodeFormat(dataInfo?.zipcode);

      // 退職者住所
      resArr.find((item) => item.keyword === "address")!.text = `${TkGetCode(
        Prefectures,
        dataInfo?.prefectureCd
      )}${dataInfo?.addressCity}${dataInfo?.addressOthers}`;

      // 退職者電話番号
      resArr.find((item) => item.keyword === "tel")!.text = dataInfo?.tel;

      // 現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である
      resArr.find(
        (item) => item.keyword === "continueTransferApplicable1Flg"
      )!.text = TkGetCode(
        ApplicableOrNotApplicable,
        dataInfo?.continueTransferApplicable1Flg
      );

      // 現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である
      resArr.find(
        (item) => item.keyword === "continueTransferApplicable2Flg"
      )!.text = TkGetCode(
        ApplicableOrNotApplicable,
        dataInfo?.continueTransferApplicable2Flg
      );

      // 転職先の共済契約者番号
      let aContractorNo = resArr.find(
        (item) => item.keyword === "aContractorNo"
      )!;
      aContractorNo.text = dataInfo?.aContractorNo;
      aContractorNo.showLine = job_33Flg;

      // 転職先の共済契約者名
      let aCorpName = resArr.find((item) => item.keyword === "aCorpName")!;
      aCorpName.text = dataInfo?.aCorpName;
      aCorpName.showLine = job_33Flg;

      // ならない月
      let exclusionMonth = resArr.find(
        (item) => item.keyword === "exclusionMonth"
      )!;
      let checkedList = exclusionMonth.checkBoxList
        ?.filter((item) =>
          ["1", "3"].includes(
            dataInfo?.[item.value as keyof typeof dataInfo] as string
          )
        )!
        .map((item) => item.label);

      exclusionMonth.setDefaultValue = checkedList?.length
        ? checkedList
        : ["無"];

      // 当月の出勤日数
      resArr.find((item) => item.keyword === "workingDayNum")!.text =
        (dataInfo?.workingDayNum ?? 0) + "日";

      // 賃金台帳
      const wagesFile = dataInfo?.formList?.find(
        (item) =>
          item.formKbn === FormKbn["退職書類"] &&
          item.formClass === FormClassRetire["賃金台帳"]
      );
      if (wagesFile) {
        let wages = resArr.find((item) => item.keyword === "wages")!;

        wages.dataname = wagesFile.fileName;
        wages.base64filedata = wagesFile.fileBase64;

        wages.showLine = true;
      }

      // 雇用契約書
      const contractEmploymentFile = dataInfo?.formList?.find(
        (item) =>
          item.formKbn === FormKbn["退職書類"] &&
          item.formClass === FormClassRetire["雇用契約書"]
      );
      if (contractEmploymentFile) {
        let contractEmployment = resArr.find(
          (item) => item.keyword === "contractEmployment"
        )!;

        contractEmployment.dataname = contractEmploymentFile.fileName;
        contractEmployment.base64filedata = contractEmploymentFile.fileBase64;

        contractEmployment.showLine = true;
      }

      setStateInfoList(resArr);
    }
  };

  const handSubmission = async (date?: any) => {
    let contractNo = isKiko
      ? businessState.common?.contractorNo
      : state.authInfo?.contractorNo;

    let businessType = "";

    if (dataInfo?.nRetireReasonCd === RetireReason["普通退職"]) {
      businessType = "JOB-32";
      dataInfo?.retireProcedureReason ===
        RetireFlowReason["法人（業務上の）都合"] &&
        (businessType = job_33Flg ? "JOB-33" : "JOB-32");
    } else {
      businessType =
        dataInfo?.retireProcedureReason ===
        RetireFlowReason["法人（業務上の）都合"]
          ? "JOB-32"
          : "JOB-31";
    }
    const param = API_STA008_BuildReqParams({
      ...businessState.job_32,
      tempSaveStep: null as any,
      contractorNo: contractNo, //共済契約者番号
      businessType, //業務タイプ
      receptionDate: date, //受付日
      screenId: "SCRC060028", //画面id
    });

    try {
      const res = await httpIAPI_STA008(param);
      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });
        navigate("/SCRC060130", {
          state: { applyId: res.applyId, staffNo: dataInfo?.staffNo },
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
        setIsOpenDialog(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC060028PageForTest" className="SCRC060028">
      <TkStepper
        steps={stepper}
        activeStep={activeStep}
        savaStep={dataInfo?.tempSaveStep}
      />
      <Box>
        <TkFakeTable list={stateInfoList} ruleSchema={{}} showButton={false} />
      </Box>

      <Box>
        <Typography>育休状況</Typography>
        <TkTable headList={childHeadList} bodyList={childBodyList} />
        <TkTable
          headList={headListWorkingDayNum}
          bodyList={childcareLeaveWorkingDayNumList}
        />
      </Box>

      <Box>
        <Typography>本俸月額登録</Typography>
        <TkTable headList={salaryHeadList} bodyList={salaryBodyList} />
      </Box>

      <Box className="SCRC060028Button">
        <TkBackButton />
        {isBtnVisible && (
          <TkButton onClick={() => setIsOpenDialog(true)}>
            {isKiko ? "申請" : "機構へ提出する"}
          </TkButton>
        )}
      </Box>

      {isKiko ? (
        <TkDateDialog
          open={isOpenDialog}
          onOky={handSubmission}
          onCancel={() => setIsOpenDialog(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請を行います）"
          contextText="申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={isOpenDialog}
          onOky={handSubmission}
          onCancel={() => setIsOpenDialog(false)}
          title="確認（機構へ提出する）"
          contextText="機構へ提出を行いますが、問題ないでしょうか。"
          okText="はい"
          cancelText="いいえ"
        />
      )}
    </Box>
  );
};

export default SCRC060028;
